import { GrayColors } from "@smartsuite/types";
import styled from "styled-components";

export const StyledGrid = styled.div<{ headerHeight: number }>`
  border: 1px solid ${GrayColors["G-1-5"]};
  border-bottom: none;
  border-radius: 5px 5px 0 0;
  height: calc(100% - ${(props) => props.headerHeight}px);

  .r-grid {
    overflow: visible;
  }

  .grid-side {
    padding-bottom: 0px;
  }

  .scrollbar__track--X {
    width: calc(100% - 0px) !important;
  }

  .activity-grid-cell {
    border-right: 1px solid ${GrayColors["G-1"]};
    height: 100%;

    &:hover {
      &:before {
        display: none;
      }
    }

    &__wrapper {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    &.is-centered {
      .activity-grid-cell__wrapper {
        justify-content: center;
      }
    }
  }

  .activity-grid-head-cell {
    border-right: 1px solid ${GrayColors["G-1"]};
    height: 100%;
    cursor: default;

    &__text {
      padding: 0 15px;
      height: 100%;
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: flex-start;
    }

    &.is-centered {
      .activity-grid-head-cell__text {
        justify-content: center;
      }
    }
  }

  .activity-grid-header {
    background-color: ${GrayColors["G-0-5"]};
    border-bottom: 1px solid ${GrayColors["G-1-5"]};
    min-width: 100%;
    border-radius: 5px 5px 0 0;
  }

  .activity-grid-row {
    border-bottom: 1px solid ${GrayColors["G-1-5"]};

    &:hover {
      background-color: ${GrayColors["G-0-5"]};
    }
`;
